<!-- 服务申请 -->
<template>
  <div>

    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div v-if="dataId" class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            CASE单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.caseNo }}</span>
            <!-- 服务类型 -->
            <span class="information">{{ formData.serverTypeName }}</span>
            <!-- 状态 -->
            <span class="information">
              {{
                formData.stat == '0' ? '待受理' : formData.stat == '1' ? '已受理' : formData.stat == '5' ? '跟进中' : formData.stat == '11' ? '已解决' : formData.stat == '99' ? '取消' : '取消'
              }}</span>
            <!-- 工单来源 -->
            <span class="information">
              <span class="information">{{ formData.orderTypeName }}</span>
            </span>
          </div>
          <div v-if="formData.stat==1" style="">

            <el-button v-if="formData.stat==1" type="primary" plain class="button-sty" @click="drawer = true"
                       icon="el-icon-thumb">一键工单
            </el-button>
            <el-button v-if="formData.stat==1" type="primary" plain class="button-sty" @click="drawer2 = true"
                       icon="el-icon-chat-line-square">
              反馈解决
            </el-button>
            <el-button v-if="formData.stat==1" type="primary" plain class="button-sty" @click="drawer3 = true"
                       icon="el-icon-close"
              style="margin-right: 60px;">拒绝
            </el-button>
            <el-button v-if="formData.stat==1" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
          </div>
        </div>

        <div v-if="!dataId" class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            {{ dataId ? '查看' : '新增' }}服务申请单
          </div>
          <div class="fr">
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
          </div>
        </div>

        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="CASE信息" name="first">
              <!-- 基本信息 -->
              <div style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
                <div class="d-cont edit-mce-box" :style="'width: ' + (dataId ? '80%' : '80%')">

                  <div class="d-item">
                    <div class="title first"><b>用户信息</b></div>
                    <table class="table-detail">
                      <tbody>
                      <tr>
                        <th>
                          <em class="f-red">*</em>
                          用户姓名
                        </th>
                        <td>
                          <el-input type="text" autocomplete="off" v-model="formData.userName"
                                    clearable :rules="[{ required: true, trigger: 'blur' }]"/>
                        </td>
                        <th>
                          <em class="f-red">*</em>
                          来电号码
                        </th>
                        <td>
                          <el-input type="text" autocomplete="off" v-model="formData.userMobile"
                                    :clearable="true" clearable :rules="[{ required: true, trigger: 'blur' }]">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="addressClickEventChan(index)"></i>/>
                          </el-input>
                        </td>
                        <th>客户单位</th>
                        <td>
                          <el-input type="text" autocomplete="off" v-model="formData.userCompany"
                                    clearable/>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <em class="f-red">*</em>
                          用户类型
                        </th>
                        <td>
                          <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.userType"   clearable>
                              <el-option label="普通用户" :value="0"/>
                              <el-option label="售前机" :value="1"/>
                              <el-option label="工程机" :value="2"/>
                              <el-option label="VIP用户" :value="3"/>
                              <el-option label="经销商" :value="4"/>
                            </el-select>
                          </el-form-item>
                        </td>
                        <th>合同号</th>
                        <td>
                          <el-input type="text" autocomplete="off" v-model="formData.contractNo"
                                    clearable/>
                        </td>
                        <th>
                          <em class="f-red">*</em>
                          工单来源:
                        </th>
                        <td>
                          <el-form-item prop="formData.orderTypeId" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.orderTypeId"   >
                              <el-option v-for="item in orderTypes" :key="item.id" :label="item.orderTypeName"
                                         :value="item.id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </td>
                      </tr>
                      <tr>

                        <th>
                          <em class="f-red">*</em>
                          地区
                        </th>
                        <td  colspan="3">

                              <el-cascader :props="areaProps" v-model="areaValues" :clearable="true"
                                           @change="handleChange" ref="cascaderAddr"
                                           style="width: 22vw!important;"
                                           :options="areaOption">
                              </el-cascader>

                        </td>
                        <th>
                          <em class="f-red">*</em>
                          详细地址
                        </th>
                        <td colspan="5">
                          <el-input type="text" autocomplete="off" v-model="formData.userAddress"   clearable/>
                        </td>

                        </tr>


                      </tbody>
                    </table>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>需求信息</b></div>
                    <table class="table-detail">
                      <tbody style="position: relative;height: 170px;">
                        <tr>
                          <th>
                          <em class="f-red">*</em>
                          服务类型
                        </th>
                        <td >

                            <el-cascader
                              style="width: 7vw!important;"
                              placeholder="请选择"
                              :props="serviceProps"
                              v-model="formData.serverTypeId"
                              :show-all-levels="false"
                              @change="changeServiceType" ref="cascaderServiceType"
                              filterable>
                            </el-cascader>

                        </td>
                        <th>
                          <em class="f-red">*</em>
                      紧急度
                        </th>
                        <td>
                          <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.guaranteeType"           style="width: 7vw!important;"    clearable>
                              <el-option label="一般" :value="0"/>
                              <el-option label="紧急" :value="1"/>
                              <el-option label="特急" :value="2"/>

                            </el-select>
                          </el-form-item>
                        </td>
                        <th>
                          <em class="f-red">*</em>
                          保修类型
                        </th>
                        <td>
                          <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.guaranteeType"         style="width: 7vw!important;"  clearable>
                              <el-option label="保内" :value="1"/>
                              <el-option label="保外" :value="2"/>
                              <el-option label="未知" :value="3"/>
                            </el-select>
                          </el-form-item>
                        </td>
                        </tr>
                      <tr style="position: absolute;">
                        <th >期待上门时间</th>
                        <td>
                          <el-date-picker v-model="formData.wishBookDate" type="date" value-format="yyyy-MM-dd HH:mm:ss"
                                          placeholder="选择日期" @change="validateTime" style="width: 7vw!important;" >
                          </el-date-picker>
                        </td>
                        <td>
                          <el-select  v-model="formData.wishBookPeriod" style="width: 10vw;" @change="validateTime" clearable>
                            <el-option label="08:00-10:00" value="08:00-10:00"/>
                            <el-option label="10:00-12:00" value="10:00-12:00"/>
                            <el-option label="12:00-14:00" value="12:00-14:00"/>
                            <el-option label="16:00 以后" value="16:00 以后"/>
                          </el-select>
                        </td>
                      </tr>

                      <tr>

                        <th>
                          <em class="f-red">*</em>
                          故障描述
                        </th>
                        <td colspan="5">
                          <el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容" size="small"
                                    v-model="formData.faultDescription" clearable
                                    :rules="[{ required: true, trigger: 'blur' }]"></el-input>
                        </td>
                      </tr>
                        <tr>
                        <th>
                          <em class="f-red">*</em>
                          述求
                        </th>
                        <td colspan="5">
                          <el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容" size="small"
                                    v-model="formData.appeals" clearable
                                    :rules="[{ required: true, trigger: 'blur' }]"></el-input>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- 产品信息 -->
                  <div class="d-item">
                    <div class="title first"><b>产品信息</b>
                    </div>
                    <div style="margin: -30px 0px 0px 51vw;;">
                      <el-button @click="addItem" type="primary" class="button-sty btn_zdy" style="margin-right: 5px;">
                        增加
                      </el-button>
                      <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除
                      </el-button>
                    </div>

                    <el-form ref="form" :rules="formRules" :inline="true" label-width="7vw" key="1"
                      style="margin-left:3px;">
                      <div v-for="(item, index) in formData.soCaseLineDTOList" :key="index"
                           style="border:1px solid #ededed;    margin: 5px;padding-top: 5px;">
                        <el-form-item label="品牌" :prop="'soCaseLineDTOList.' + index + '.name'" :rules="{
                          required: true, message: '品牌不能为空', trigger: 'blur'
                        }">
                          <el-select v-model="formData.soCaseLineDTOList[index].brandId" style="width: 8vw;" clearable
                                     filterable>
                            <el-option v-for="item in brands" :key="item.id"
                                       :label="item.brandName"
                                       :value="item.id">
                            </el-option>

                          </el-select>
                        </el-form-item>

                        <el-form-item label="产品大类" :prop="'soCaseLineDTOList.' + index + '.bigCategoryId'" :rules="[
                  { required: true, message: '产品大类不能为空', trigger: 'blur' },

                          ]">
                          <el-select v-model="formData.soCaseLineDTOList[index].bigCategoryId" style="width: 8vw;"
                                     @change="changeBigCategorys($event,index)" clearable filterable>
                            <el-option v-for="item in bigCategorys" :key="item.id" :label="item.categoryName"
                                       :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="产品小类" :prop="'soCaseLineDTOList.' + index + '.smallCategoryId'">
                          <el-select v-model="formData.soCaseLineDTOList[index].smallCategoryId" style="width: 8vw;"
                                     @change="changeSmallCategorys()" clearable filterable>
                            <el-option v-for="item in smallCategorys[index]" :key="item.id" :label="item.categoryName"
                                       :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品编码" :prop="'soCaseLineDTOList.' + index + '.itemCode'" :rules="{
                  required: true, message: '产品编码不能为空', trigger: 'blur'
                }">
                          <el-input v-model="formData.soCaseLineDTOList[index].itemCode" style="width: 8vw;" readonly>
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="selectItem(index)"></i>

                          </el-input>
                        </el-form-item>
                        <el-form-item label="产品名称" :prop="'orderLine.' + index + '.itemName'">

                          <el-input v-model="formData.soCaseLineDTOList[index].itemName" style="width: 8vw;" readonly>
                            <!--                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>-->
                          </el-input>
                        </el-form-item>
                        <el-form-item label="数量" :prop="'soCaseLineDTOList.' + index + '.qty'" :rules="{
                  required: true, message: '数量不能为空', trigger: 'blur'
                }">
                          <el-input type="number" min="1"  v-model="formData.soCaseLineDTOList[index].qty"
                                    style="width: 8vw;"></el-input>
                        </el-form-item>

<!--                        <el-form-item label="图片1" :prop="'orderLine.' + index + '.pic1'">-->
<!--                          <td colspan="">-->
<!--                            <div>-->
<!--                              <el-upload style="width: 40px;height: 40px;" :class="{hide_box4: upload_btn1}"-->
<!--                                         :action="uploadFileUrl" :on-remove="handleRemove1" list-type="picture-card"-->
<!--                                         :file-list="picList1"-->
<!--                                         :on-success="(res,file, fileList) => {handleSuccess1(res,file, fileList)}"-->
<!--                                         :on-change="(files, fileList) => {handleImageChange(fileList)}"-->
<!--                                         :auto-upload="true" :headers="headers"-->
<!--                                         :on-preview="handlePictureCardPreview"-->
<!--                              >-->
<!--                                <i slot="default" class="el-icon-plus"></i>-->
<!--                              </el-upload>-->
<!--                            </div>-->
<!--                          </td>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="图片2" :prop="'orderLine.' + index + '.pic2'">-->
<!--                          <td colspan="">-->
<!--                            <div>-->
<!--                              <el-upload style="width: 40px;height: 40px;" :class="{hide_box4: upload_btn2}"-->
<!--                                         :action="uploadFileUrl" :on-remove="handleRemove2" list-type="picture-card"-->
<!--                                         :file-list="picList2"-->
<!--                                         :on-success="(res,file, fileList) => {handleSuccess2(res,file, fileList)}"-->
<!--                                         :on-change="(files, fileList) => {handleImageChange(fileList)}"-->
<!--                                         :auto-upload="true" :headers="headers"-->
<!--                                         :on-preview="handlePictureCardPreview"-->
<!--                              >-->
<!--                                <i slot="default" class="el-icon-plus"></i>-->
<!--                              </el-upload>-->
<!--                            </div>-->
<!--                          </td>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="图片3" :prop="'orderLine.' + index + '.pic3'">-->
<!--                          <td colspan="">-->
<!--                            <div>-->
<!--                              <el-upload style="width: 40px;height: 40px;" :class="{hide_box4: upload_btn3}"-->
<!--                                         :action="uploadFileUrl" :on-remove="handleRemove3" list-type="picture-card"-->
<!--                                         :file-list="picList3"-->
<!--                                         :on-success="(res,file, fileList) => {handleSuccess3(res,file, fileList)}"-->
<!--                                         :on-change="(files, fileList) => {handleImageChange(fileList)}"-->
<!--                                         :auto-upload="true" :headers="headers"-->
<!--                                         :on-preview="handlePictureCardPreview"-->
<!--                              >-->
<!--                                <i slot="default" class="el-icon-plus"></i>-->
<!--                              </el-upload>-->
<!--                            </div>-->
<!--                          </td>-->
<!--                        </el-form-item>-->



                      </div>
                    </el-form>


                  </div>

                  <div style="height:80px"></div>
                </div>
                <div v-if="dataId" style="width: 20%;" class="bread">
                  <div style="padding-bottom: 90px;    margin-top: 10px; margin-left: 5px;">
                    <div v-if="formData.orderNo" class="title_icon"><i class="el-icon-date"></i></div>
                    <span v-if="formData.orderNo">工单履历</span>
                    <div>
                      <div v-if="formData.orderNo" class="card">
                        <div class="card-item1"><span>{{ formData.orderNo }}</span> <span class="details"
                                                                                          @click="addressClickEvent(formData.orderId)">详情</span>
                        </div>
                        <div><span>工单状态: </span>
                          {{
                            formData.orderStat == '1' ? '登记' : formData.orderStat == '2' ? '发布' : formData.orderStat ==
                            '5' ? '已派网点' : formData.orderStat == '9' ? '已派师傅' : formData.orderStat == '13' ? '已出发' : formData.orderStat
                            == '17' ? '已上门' : formData.orderStat == '20' ? '完工暂存' : formData.orderStat ==
                            '21' ? '已完工' : formData.orderStat == '22' ? '网点确定完工' : formData.orderStat ==
                            '23' ? '中心确定完工' : formData.orderStat == '24' ? '总部确定完工' : formData.orderStat ==
                            '91' ? '待结算' : formData.orderStat == '92' ? '结算驳回' : formData.orderStat ==
                            '93' ? '结算中止' : formData.orderStat == '94' ? '已结算' : formData.orderStat == '98' ? '挂起' : '取消'
                          }}
                          <div><span>创建时间: </span><span>{{ formData.orderCreateTime }}</span></div>
                          <div><span>完工时间: </span><span>{{ formData.orderFinishTime }}</span></div>
                          <div><span>服务网点: </span><span>{{ formData.orderSiteName }}</span></div>
                        </div>
                      </div>
                      <div>
                        <div style="margin-top: 10px;">
                          <div class="title_icon"><i class="el-icon-s-order"></i></div>
                          <span>处理日志</span>
                        </div>

                        <el-timeline class="card_bread" style="position:relative">

                          <el-timeline-item v-for="item in formData.soCaseOperationDTOList" placement="top">
                            <div class="title_time"><span class="span1">{{ item.title }}</span>
                              <span class="span2">{{ item.createTime }}</span>
                            </div>
                            <el-card class="card">
                              <p>{{ item.content }}</p>
                            </el-card>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
<!--            <el-tab-pane label="处理信息" name="second">-->

<!--            </el-tab-pane>-->


          </el-tabs>
        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <!-- <div style="height: 100vh; width: 5px; background-color: aquamarine;"></div> -->
    <el-drawer title="一键工单" :before-close="handleClose" :visible.sync="drawer" direction="rtl" custom-class="demo-drawer"
      ref="drawer">
      <div class="demo-drawer__content">

        <div style="font-size: 12px;color: rgba(86, 86, 86, 0.96); margin-top:30px">
          <span style="text-align: right;    width: 77px;display: block; margin-bottom: 10px;">操作方式：</span>
          <el-radio-group v-model="radio" @change="radioHandleChange" style="margin-left: 50px;
    margin-bottom: 10px;">
            <el-radio :label="1">自动派工</el-radio>
            <el-radio :label="2">派服务中心</el-radio>
            <!-- 网点框 -->
            <el-radio :label="3">定向派工</el-radio>
            <el-radio :label="4">督办人</el-radio>


          </el-radio-group>
        </div>
        <el-form :model="form2">
          <el-form-item label="指派中心" :label-width="formLabelWidth">
            <el-input v-model="formData.assignOrgName" autocomplete="off" :disabled="isdisabledFn" style="width:165px">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="assignOrg"></i>


            </el-input>
          </el-form-item>
          <el-form-item label="指派网点" :label-width="formLabelWidth">
            <el-input v-model="formData.siteName" autocomplete="off" :disabled="isdisabledFn2" style="width:165px">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="assignSite"></i>


            </el-input>
          </el-form-item>
          <el-form-item label="督办人" :label-width="formLabelWidth">
            <el-input v-model="formData.managerName" autocomplete="off" :disabled="isdisabledFn3" style="width:165px">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="assignAdmin"></i>

            </el-input>
          </el-form-item>
        </el-form>

        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="createOrder" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="反馈解决" :before-close="handleClose" :visible.sync="drawer2" direction="rtl" custom-class="demo-drawer"
      ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="解决措施" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.reason"
              autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="feedbackResolution" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="拒绝" :before-close="handleClose" :visible.sync="drawer3" direction="rtl" custom-class="demo-drawer"
      ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="拒绝原因" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.reason"
              autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="refuse" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 网点选择弹窗 -->
    <siteDialog v-if="showSiteDialog" @commitSiteRow="commitSiteRow"
                :visiable.sync="showSiteDialog" multi="true" :param="assignSiteParam"/>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" multi="true" :param="itemDialogParam"/>
    <!-- /督办人弹框 -->
    <duDialog v-if="showDbDialog" @commitAdminRow="commitAdminRow"
              :visiable.sync="showDbDialog" multi="true"/>
    <!-- 指派中心弹框 -->
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect"
                  :visiable.sync="showOrgDialog" multi="true" />
    <detailsDialog v-if="showPreconditionDialog2" @closeD="closeD"  :row1="row1"
                  :visiable.sync="showPreconditionDialog2" multi="true"/>
    <custProfileDialog v-if="showCustProfileDialog" @commitAdminRow="commitChanPinRow"
                  :visiable.sync="showCustProfileDialog" multi="true"/>
  </div>
</template>

<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
//  网点选择弹窗
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue';
//  督办人选择弹窗
import assignDialog from "@/views/dialogCommon/orgDialog";
import duDialog from "@/views/dialogCommon/adminDialog";
// 产品型号
import preconditionDialog from '../../../dialogCommon/itemDialog';
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";
import custProfileDialog from "@/views/dialogCommon/custProfileDialog.vue";

import store from "@/store";
// important adminDialog from "@/";
// 城市三级联动
import {
  regionData,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import api from "@/api/projectApi";
import {fetchTree} from "@/api/admin/type_tree";
import siteDialog from "@/views/workorder/orderaccess/access/dialogWangdian.vue";

const cityOptions = ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频', '挂壁式（Q＜3200W）', '挂壁式 3200W≤Q≤3600W 变频'];
const cityOptions2 = ['挂壁式1变频', '挂壁式222变频', '挂壁式3', '挂壁式 4'];
export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    //  网点选择弹窗
    siteDialog,
//  督办人选择弹窗
    assignDialog,
    duDialog,
    // 产品
    preconditionDialog,
    // 表格数据点击弹出层
    detailsDialog,
    custProfileDialog,
  },
  data() {
    return {
      row1: null,
      showPreconditionDialog2: false,
      showCustProfileDialog:false,
      showSiteDialog:false,
      showOrgDialog:false,
      // 督办人弹框
      showDbDialog: false,
      isdisabledFn: true,
      isdisabledFn2: true,
      isdisabledFn3: true,

      form2: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '80px',
      timer: null,
      drawer: false,
      drawer2: false,
      loading: false,
      drawer3: false,
      formRules: {},
      rules: {},
      //工单来源
      orderTypes: [],
      serviceProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.getServiceType
      },
      //指派网点传的参数
      assignSiteParam:{

      },
      //品牌
      brands: [],
      //产品大类
      bigCategorys: [],
      //产品小类
      smallCategorys: [],
      itemDialogParam: {
        usable: 1
      },

      areaValues: [],
      areaOption: [],
      value1: '',
      // 产品信息 数据
      form: {
        stat: null,

        dynamicItem: [
          {
            name: "",
            bigCategoryName: ""
          }
        ]
      },
      show3: false,
      node: true,
      formData: {
        orderId:'',//case单对应生成的工单id
        orderNo: 0,//case单对应生成的工单号
        caseNo: '', // case单号,前缀"SO"+年月日+6位流水号
        serverTypeName: '',//服务类型名称
        orderStat: '',//工单状态
        stat: 0,//case单状态
        orderTypeName: '',//来源名称
        createType: 1, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: '', // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        contractNo: '', // 合同号
        userCompany: '', // 客户单位
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 1, // 保修类型：1保内、2保外、3未知
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        faultDescription: '',
        appeals: '', // 述求
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        orderServiceTypeName: '',//工单服务类型名称
        orderCreateTime: '',//工单创建时间
        orderFinishTime: '',//工单完工时间
        orderSiteName: '',//工单网点名称
        urger: '',
        wishBookDate: '',
        wishBookPeriod: '',
        siteName:'',
        managerName:'',
        siteId:'',
        managerId:'',
        assignOrgId:'',
        assignOrgName:'',
        soCaseOperationDTOList: [],
        soCaseLineDTOList: [
          {qty:1}
        ]
      },
      srcList: [],


      ////////////////////////////////////////////////////////////////////////////////////////////
      card: true,
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      showPreconditionDialog: false,
      // show
      checkAll: false,
      checkAll2: false,
      checkedCities: ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频'],
      checkedCities2: ['挂壁式1变频',],
      cities: cityOptions,
      cities2: cityOptions2,
      isIndeterminate: true,
      isIndeterminate2: true,
      // 以上卡片数据

      img_b: "",
      //认证信息-- 资质照片-测试数据

      big_img: [
        'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
      ],
      // showParameterDialog: false,
      showSaleConfigDialog: false,
      upload_btn: false, // 是否隐藏上传图片按钮
      upload_btn4: false, // 是否隐藏上传图片按钮
      radio: 1,
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      showProductCategoryDialog: false,
      languageDTOs: [],
      dialogImageUrl: '',
      dialogVisible: false,
      uploadDisabled: false,
      upload_img: [

        // imageList: [], //图片数据列表,用于之后上传到后端
        // imageName: []  //图片名称
      ],

      //地址选择
      selectemp: {},
      selectedOptions: [],
      options: regionData,
      // 费用配置表
    };
  },
  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData();
    this.getBrands();
    this.getOrderTypes();
    this.getBigCategorys();
  },
  methods: {
    closeD(v){
      this.showPreconditionDialog2 = v
    },
    commitOrgSelect(data){
      this.formData.assignOrgId = data.id;
      this.formData.assignOrgName = data.name;
    },
    commitChanPinRow(data){
      this.formData.assignOrgId = data.id;
      this.formData.assignOrgName = data.name;
    },
    radioHandleChange(val) {
      console.log(val, "val-选中的radio")
      if (val == 2) {
        this.radio = 2
        this.isdisabledFn = false
        this.isdisabledFn2 = true
        this.isdisabledFn3 = true
        this.formData.siteName = ''
        this.formData.siteId = ''
        this.formData.managerId = ''
        this.formData.managerName = ''
        // this.showPreconditionDialog=true
      } else if (val == 3) {
        this.radio = 3
        // this.showSiteDialog = true
        this.isdisabledFn2 = false
        this.isdisabledFn = true
        this.isdisabledFn3 = true
        this.formData.assignOrgName = ''
        this.formData.assignOrgId = ''
        this.formData.managerId = ''
        this.formData.managerName = ''
      } else if (val == 4) {
        this.radio = 4
        this.isdisabledFn3 = false
        this.isdisabledFn2 = true
        this.isdisabledFn2 = true
        this.formData.assignOrgName = ''
        this.formData.assignOrgId = ''
        this.formData.siteName = ''
        this.formData.siteId = ''
      } else {
        this.radio = 1;
        this.isdisabledFn = true
        this.isdisabledFn2 = true
        this.isdisabledFn3 = true
        this.formData.assignOrgName = ''
        this.formData.assignOrgId = ''
        this.formData.siteName = ''
        this.formData.siteId = ''
        this.formData.managerId = ''
        this.formData.managerName = ''
      }
    },
    assignOrg() {
      // 对应上radio的值   再能打开弹框
      if (this.radio == 2) {
        this.showOrgDialog = true
      }
    },
    //获取工单来源
    getOrderTypes() {
      request({
        url: '/basic/basOrderType/getLists',
        method: 'post',
        data: {
          isShowIssue: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.orderTypes = response.data.data;
      })
    },
    //获取服务类型
    getServiceType(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: '/basic/basServiceType/getList',
        method: 'post',
        data: {
          parentId: node.value,
          isShowIssue: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.serviceTypeName,
          typedValue: item.businessType,
          leaf: !item.hasChild
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
    getBrands() {
      request({
        url: '/basic/snCompanyBrand/getBrandList',
        method: 'post',
        data: {
          usable: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.brands = response.data.data;
      })
    },
    //获取产品大类
    getBigCategorys() {
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.bigCategorys = response.data.data;
      })
    },
    addressClickEvent(row){
      this.row1=row
      this.showPreconditionDialog2 = true
    },
    addressClickEventChan(row){
      this.row1=row
      this.showCustProfileDialog = true
    },
    //指派网点
    assignSite() {
      // 对应上radio的值   再能打开弹框
      if (this.radio == 3) {
        this.showSiteDialog = true
      }
    },
    //指派督办人
    assignAdmin() {
      // 对应上radio的值   再能打开弹框
      if (this.radio == 4) {
        this.showDbDialog = true
      }
    },
    // 网点选中
    commitSiteRow(data) {
      console.log(data, '网点选中')
      this.formData.siteId = data.id
      this.formData.siteName = data.name
    },
    commitSelectedRow(data, index) {
      this.formData.soCaseLineDTOList[index].bigCategoryName = data.bigCategoryName;
      this.formData.soCaseLineDTOList[index].smallCategoryName = data.smallCategoryName;
      this.formData.soCaseLineDTOList[index].bigCategoryId = data.bigCategoryId;
      this.changeBigCategorys(data.bigCategoryId, index);
      this.formData.soCaseLineDTOList[index].smallCategoryId = data.smallCategoryId;
      this.formData.soCaseLineDTOList[index].entId = data.entId;
      this.formData.soCaseLineDTOList[index].brandId = data.brandId;
      this.formData.soCaseLineDTOList[index].itemId = data.id;
      this.formData.soCaseLineDTOList[index].itemName = data.name;
      this.formData.soCaseLineDTOList[index].itemCode = data.code;
      this.formData.soCaseLineDTOList[index].entId = data.entId;
      this.formData.soCaseLineDTOList[index].brandId = data.brandId;
    },

    //确定选择督办人
    commitAdminRow(data) {
      this.formData.managerId = data.id;
      this.formData.managerName = data.username;
    },

    //期待上门时间不能小于当前时间
    validateTime() {
      const selectedDate = new Date(this.formData.wishBookDate); // 将选择的日期转换为Date对象
      const currentTime = new Date(); // 当前时间
      selectedDate.setHours(0, 0, 0, 0); // 将选择的时间设置为当天的0点0分0秒
      if (selectedDate.getDate() < currentTime.getDate()) {
        // 如果选择的日期与当前日期相同，并且选择的时间小于当前时间，则重置选择框的值
        this.formData.wishBookDate = '';
        this.$message.error('选择的日期不能小于当前日期');
      }else if(selectedDate.getDate() == currentTime.getDate()){
        const selectBookPeriod = this.formData.wishBookPeriod;
        if(selectBookPeriod=='08:00-10:00'){
          if(currentTime.getHours()>=10){
            this.formData.wishBookPeriod = '';
            this.$message.error('选择的时间段不能小于当前时间');
          }
        }else if(selectBookPeriod=='10:00-12:00'){
          if(currentTime.getHours()>=12){
            this.formData.wishBookPeriod = '';
            this.$message.error('选择的时间段不能小于当前时间');
          }
        }else if(selectBookPeriod=='12:00-14:00'){
          if(currentTime.getHours()>=14){
            this.formData.wishBookPeriod = '';
            this.$message.error('选择的时间段不能小于当前时间');
          }
        }
      }
    },

    //修改服务类型
    changeServiceType() {
      const serviceType = this.$refs["cascaderServiceType"].getCheckedNodes();
      if (serviceType != null && serviceType[0] != null && serviceType[0].value != null) {
        this.formData.serverTypeId = serviceType[0].value;
      } else {
        this.formData.serverTypeId = "";
      }
      const panelRefs = this.$refs.cascaderServiceType.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    async refuse() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.soCase.refuseUrl, {orderId: this._dataId, remark: this.form2.reason});
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    async feedbackResolution() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.soCase.feedbackResolutionUrl, {
          orderId: this._dataId,
          remark: this.form2.reason
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    async createOrder() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.soCase.createOrderUrl, {
          radio: this.radio,
          orderId:this._dataId,
          assignOrgId: this.formData.assignOrgId,
          assignOrgName: this.formData.assignOrgName,
          siteId:this.formData.siteId,
          siteName:this.formData.siteName,
          managerId:this.formData.managerId,
          managerName:this.formData.managerName
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    handleClose(done) {
      if (this.loading) {
        return;
      }
      this.$confirm('是否关闭操作窗？')
        .then(_ => {
          // this.loading = true;
          this.timer = setTimeout(() => {
            done();
            // 动画关闭需要一定的时间
            setTimeout(() => {
              // this.loading = false;
              this.cancelForm()
            }, 400);
          }, 1000);
        })
        .catch(_ => {
          this.cancelForm()
        });
    },
    changeBigCategorys(val, index) {
      this.formData.soCaseLineDTOList[index].smallCategoryId = "";
      this.formData.soCaseLineDTOList[index].itemId = "";
      this.formData.soCaseLineDTOList[index].itemCode = "";
      this.formData.soCaseLineDTOList[index].itemName = "";
      this.formData.soCaseLineDTOList[index].entId = "";
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1,
          parentId: val
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$set(this.smallCategorys, index, response.data.data);
      })
    },
    //选择产品小类
    changeSmallCategorys() {
      this.$forceUpdate()
      console.log(this.formData.soCaseLineDTOList[index].smallCategoryId)
    },
    //选择产品
    selectItem(index) {
      this.showPreconditionDialog = true;
      this.itemDialogParam.brandId = this.formData.soCaseLineDTOList[index].brandId;
      this.itemDialogParam.searchBrandName = this.formData.soCaseLineDTOList[index].brandName;
      this.itemDialogParam.bigCategoryId = this.formData.soCaseLineDTOList[index].bigCategoryId;
      this.itemDialogParam.smallCategoryId = this.formData.soCaseLineDTOList[index].smallCategoryId;
      this.itemDialogParam.indexNum = index;
    },
    cancelForm() {
      this.radioHandleChange();
      this.loading = false;
      this.drawer = false;
      this.drawer2 = false;
      this.drawer3 = false;
      clearTimeout(this.timer);
    },
    // 添加
    addItem() {
      this.formData.soCaseLineDTOList.push({qty:1});
      this.smallCategorys.push([])
    },
    sure(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除产品
    deleteItem(item, index) {
      // console.log(item,index,"indexde");
      if (this.formData.soCaseLineDTOList.length > 1) {
        this.smallCategorys.splice(this.smallCategorys.length - 1, 1);
        this.formData.soCaseLineDTOList.splice(this.formData.soCaseLineDTOList.length - 1, 1);
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },
    // // 大小类型
    // selectOne() {
    //   this.company.smallCategoryId = null;
    //   this.init1()
    // },
    //
    // init(_node, _data, _name) {
    //   fetchTree(this.tree).then(response => {
    //     this.options = []
    //     response.data.data.forEach(item => {
    //       this.options.push({
    //         label: item.categoryName,
    //         value: item.id
    //       })
    //     })
    //   });
    // },
    // init1() { // 子类选择器加载
    //   fetchTree({
    //     categoryName: '',
    //     categoryCode: "",
    //     parentId: this.company.bigCategoryId,
    //     categoryType: 1,
    //     usable: 1
    //   }).then(response => {
    //     this.options1 = []
    //     response.data.data.forEach(item => {
    //       this.options1.push({
    //         label: item.categoryName,
    //         value: item.id
    //       })
    //     })
    //   });
    //   console.log(this.options1, "this.options1的值");
    // },
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.formData.areaId = node.value;
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // saveData() {
    //   request({
    //     url: '/basic/soCase/saveOrUpdate',
    //     method: 'post',
    //     data: this.formData,
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then(response => {
    //     if (response.code == 0) {
    //       this.$message({message: 'success', type: 'success'});
    //       this.$router.go(0);
    //     } else {
    //       this.$message({message: response.content, type: 'warning'});
    //     }
    //   })
    // },

    saveData() {
      console.log('保存数据', this.formData)
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()

        this.$http({
          url: '/basic/soCase/saveOrUpdate',
          method: 'post',
          data: this.formData
        }).then(() => {
          this.$message.success("保存成功！");
          // this.$emit('editViewDataUpdate')
          // this.$baseReload()
          this.reload()
          this.$mask.close()

        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！");
          this.$mask.close()

        })
      })
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 地址三级联动
    handleChange() {
      console.log(
        this.$refs["cascaderAddr"].getCheckedNodes(),
        "选择地址"
      );
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.formData.areaId = areaNode.value;
        if (areaNode[0].level == 1) {
          this.formData.userProvice = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvice = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
      } else {
        this.formData.areaId = null;
        this.formData.userProvice = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.soCase.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data;
          if (this.formData.areaId !== null && this.formData.areaId !== '') {
            // this.cascaderShow = false
            this.$http({
              url: api.basArea.echoAddressUrl,
              method: 'post',
              data: {id: this.formData.areaId}
            }).then(res => {
              // console.log(res)
              this.areaOption = res.data.data.options
              this.areaValues = res.data.data.values
              // this.area = res.data.data.names
            })
          }
          if (this.formData.soCaseLineDTOList && this.formData.soCaseLineDTOList.length > 0) {
            // 当前列表不为空且长度大于 0
            for (let i = 0; i < this.formData.soCaseLineDTOList.length; i++) {
              request({
                url: '/basic/basItemCategory/getChildrens',
                method: 'post',
                data: {
                  usable: 1,
                  categoryType: 1,
                  parentId: this.formData.soCaseLineDTOList[i].bigCategoryId
                },
                isLoading: true,
                modalStrictly: true,
              }).then(response => {
                this.$set(this.smallCategorys, i, response.data.data);
              })
            }
          }
          console.log(this.formData);
        })
      } else {
        this.enabled = true;
      }
    },
    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    searchEvent(){
      if (this.userMobile== null || this.userMobile ==""){
        return false;
      }
      request({
        url: '/basic/soOrderIssue/getOrderAndProfileByModile',
        method: 'post',
        data: {
          userMobile:this.userMobile
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.mobile = response.data.data;
      })
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload el-upload--picture-card {
  width: 40px;
  height: 40px;
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 210px;
  border-radius: 5px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #2a6494;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #2a6494 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}


::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}



// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #2a6494;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #2a6494 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
// #containt .table-detail tbody tr td {
//   padding: 5px 12px;
//   width: 172.2px;
//   height: 27.2px !important;
//   word-break: break-word;
// }

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

// #containt .table-detail tbody tr td {
//   width: 9.5vw !important;
//   ;
// }
// ::v-deep .el-input--medium .el-input__inner{
//   width: 9.5vw!important;
// }
::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

// 产品信息 title 宽度
.el-form--inline .el-form-item__label {
  width: 8.15vw !important;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px !important;
  vertical-align: top;
}

::v-deep .el-form-item__label {
  padding: 0 4px 0 0 !important;
}

// #containt .table-detail tbody tr td[data-v-7297c694] {
//   padding: 5px 12px;
//   width: 11vw !important;
//   height: 27.2px !important;
//   word-break: break-word;
// }

#containt .title {
  width: 20%;
}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

// 右边卡片样式
.card {
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;

  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 0px;
  background-color: #f2f2f2;
  padding-left: 10px !important;
  padding-right: 5px;
  padding-bottom: 0px;
  margin-bottom: 20px;

  .card-item1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      font-size: 13px;
      font-weight: 550;
    }

    .details {
      text-decoration: underline;
      color: #2a6494 !important;
    }
  }

  >div {
    margin-bottom: 8px;
  }
}

.card2 {
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 0px !important;
  background-color: #f2f2f2;
  padding-left: 0px !important;
  /* padding-right: 0px; */
  padding-bottom: 0 !important;
  margin-bottom: 0px !important;
}


.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #2a6494 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 7vw !important;
  height: 39.2px;
  word-break: break-word;
}

#containt .table-detail tbody tr th {
  // white-space: nowrap;
  width: 7vw !important;
}
</style>
